import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';

function CardSection(_param) {
    var { children , flex , className , spacing ='l'  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "flex",
        "className",
        "spacing"
    ]);
    return /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({
        className: classnames('card-section', `card-section--spacing-${spacing}`, className, {
            'card-section--flex': flex
        })
    }, rest), children);
}

export { CardSection as default };
//# sourceMappingURL=CardSection.js.map
